module.exports = __webpack_public_path__ + "img/photo-54.2e7dd3f3.webp";